module.exports = __webpack_public_path__ + "img/mobile-eye-large.efad460f.svg";